// List the authenticated user's own patches from Supabase.
//
// Step 1 of the cloud-first library refactor: a read-only path that
// surfaces every row you own — including ones authored externally
// (e.g. via the MCP server) that the localStorage-backed Songs panel
// can't see today.
//
// RLS on the `patches` table enforces auth.uid() = owner_id, so the
// explicit owner_id eq is defensive — it short-circuits the round-trip
// when the session is unauthenticated and makes the intent obvious to
// readers.

import { getSupabase } from '../auth/client';

export type PatchVisibility = 'public' | 'unlisted' | 'private';

export type CloudPatchRow = {
  id: string;
  title: string;
  code: string;
  visibility: PatchVisibility;
  created_at: string;
  updated_at: string;
};

export async function listMyPatches(): Promise<CloudPatchRow[]> {
  const supabase = getSupabase();
  if (!supabase) return [];

  const { data: sessionData } = await supabase.auth.getSession();
  const session = sessionData.session;
  if (!session) return [];

  const { data, error } = await supabase
    .from('patches')
    .select('id, title, code, visibility, created_at, updated_at')
    .eq('owner_id', session.user.id)
    .order('updated_at', { ascending: false });
  if (error) throw new Error(`listMyPatches failed: ${error.message}`);
  return (data ?? []) as CloudPatchRow[];
}
